<template>
    <div class="container" v-loading="loading">
        <el-table
                :data="activeUserList"
                style="width: 100%">
            <el-table-column
                    header-align="center"
                    align="center"
                    type="index"
                    label="id"
                    width="50">
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="user_key"
                    label="user_key">
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="ip"
                    label="IP"
            >
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="port"
                    label="port"
            >
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    label="连接时间"
            >
                <template slot-scope="scope">
                    {{scope.row.addts | tsToDateTime}}
                </template>
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="columnProp"
                    label="操作"
            >
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="viewConnection(scope.row)">连接记录</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
  import {apiGetActivedUser} from "@/api";

  export default {
    name: 'activedUser',
    components: {},
    data() {
      return {
        activeUserList: [],
        loading: false
      }
    },
    mounted() {
      this.getActiveddUser()
    },
    methods: {
      viewConnection ({user_key}) {
        this.$router.push({
          name: 'connectionRecords',
          props: true,
          params: {
            user_key
          }
        })
      },
      async getActiveddUser() {
        try {
          this.loading = true
          const res = await apiGetActivedUser()
          console.log(res);
          this.activeUserList = res.data.active_user_list.map(a => a.info)
          // this.activeUserList = [{
          //   "id": 1,
          //   "user_key": "sedexo1",
          //   "ip": "41.28.66.166",
          //   "port": 56166,
          //   "addts": 1510526542
          // }]
          this.loading = false
        } catch (e) {
          this.loading = false
          console.log(e);
        }
      }
    },
    computed: {},
    watch: {}
  }
</script>
<style lang="scss" scoped>

</style>
